module.exports = vendor_0c24fb4ba06bcd34cf1f;


//////////////////
// WEBPACK FOOTER
// external "vendor_0c24fb4ba06bcd34cf1f"
// module id = 8
// module chunks = 53